module.exports = __webpack_public_path__ + "img/mh-valve-logo.5008aa1f.jpg";